<template>
  <div class="departments container">

    <!-- ------------------------------- Modal: Add/Modify departments ------------------------------------------ -->

    <div>
		<CModal title="Department Details" color="info" :show.sync="departmentModal" size="lg">		  
			<div slot="footer">
				<button class="btn btn-info" v-on:click.prevent="serverCall('addUpdateDept')">Save</button>
				<button class="btn btn-info ml-2" v-on:click.prevent="departmentModal=false">Close</button>
			</div>

			<form>
				<div class="form-group row">
					<label for="name" class="col-sm-2 col-form-label text-right">Name</label>
					<div class="col-sm-10">
						<input type="text" id="name" class="form-control" 
								v-model="dept.name" required="">
					</div>
				</div>

				<div class="form-group row">
					<label for="inTime" class="col-sm-2 col-form-label text-right">In-Time</label>
					<vue-timepicker format="hh:mm A" v-model="dept.inTime" 
							class="col-sm-3" hide-clear-button>
					</vue-timepicker>
						<!--
						<input type="text" id="inTime" class="form-control" 
								v-model="dept.inTime" required="">
						-->
					<label for="inTimeTolerance" class="col-sm-3 col-form-label text-right">in-Time Tolerance</label>
					<div class="col-sm-3">
						<input type="number" min=0 id="inTimeTolerance" class="form-control" 
								v-model="dept.inTimeTolerance" >
					</div>
				</div>

				<div class="form-group row">
					<label for="outTime" class="col-sm-2 col-form-label text-right">Out-Time</label>
					<vue-timepicker format="hh:mm A" v-model="dept.outTime" 
							class="col-sm-3" hide-clear-button>
					</vue-timepicker>

					<label for="outTimeTolerance" class="col-sm-3 col-form-label text-right">Out-Time Tolerance</label>
					<div class="col-sm-3">
						<input type="number" min=0 id="outTimeTolerance" class="form-control" 
								v-model="dept.outTimeTolerance" >
					</div>
				</div>

				<label for="dept.daysOff" class="col-sm-2 col-form-label text-right">Days Off:</label>
				<div class="col-sm-10">
					<input type="checkbox" class="mr-1" id="sat" value="5" v-model="dept.daysOff">
					<label for="sat" class="mr-3">Sat</label>

					<input type="checkbox" class="mr-1" id="sun" value="6" v-model="dept.daysOff">
					<label for="sun" class="mr-3">Sun</label>

					<input type="checkbox" class="mr-1"id="mon" value="0" v-model="dept.daysOff">
					<label for="mon" class="mr-3">Mon</label>

					<input type="checkbox" class="mr-1" id="tues" value="1" v-model="dept.daysOff">
					<label for="tues" class="mr-3">Tues</label>

					<input type="checkbox" class="mr-1" id="wed" value="2" v-model="dept.daysOff">
					<label for="wed" class="mr-3">Wed</label>

					<input type="checkbox" class="mr-1" id="thurs" value="3" v-model="dept.daysOff">
					<label for="thurs" class="mr-3">Thurs</label>

					<input type="checkbox" class="mr-1" id="fri" value="4" v-model="dept.daysOff">
					<label for="fri" class="mr-3">Fri</label>

				</div>

				<p class="text-danger" align="left">{{deptAlert}}</p>
			</form>

		</CModal>
	</div>

    <!-- ---------------------------------------  Department List -------------------------------------------------- -->

	<vue-good-table ref="deptsTable" :columns="colDepts" :rows="rowDepts" 
							@on-row-click="rowChanged" 
							:selectOptions="{
									enabled: true,
									selectOnCheckboxOnly: false, 
							}">
			<div slot="table-actions">
				<CButton class="mr-3" color="primary" v-on:click.prevent="openNewDeptDetails()">
					Add
				</CButton>
			</div>
			<div slot="selected-row-actions">
				<CButton color="info" v-on:click.prevent="openExistingDeptDetails()">
					Modify
				</CButton>
				<CButton class="ml-2" color="info" v-on:click.prevent="serverCall('deleteDept')">
					Delete
				</CButton>
			</div>
	</vue-good-table>
	
	<p class="text-danger" align="left">{{alert}}</p>

	<main id="main">
	</main>

  </div>
</template>

<script>
import axios from "axios"
import VueTimepicker from 'vue2-timepicker/src/vue-timepicker.vue'
import { firebase } from '@firebase/app'
import "firebase/auth"

export default {
	name: 'departments',

    components: {
		VueTimepicker,
	},
		
	data () {
		return {
			alert: '',
			deptAlert: '',

			departmentModal: false,

			depts: [],

			dept: {
					deptDocId: '',
					name: '',
					inTime: '09:00 AM',
					inTimeTolerance: 0,
					outTime: '05:30 PM',
					outTimeTolerance: 0,
					daysOff: []
			},

			addFlag: false,

			colDepts: [
					{
							label: 'Name',
							field: 'name',
							html: false
					}
			],

			rowDepts: [],
			curRowSelected: null,	
		}
	},

	computed: {
	},

	mounted(){
		this.serverCall('getDepts')
	},

	methods: {

        serverCall(name) {
            var self = this
			self.alert = null

			firebase.auth().onAuthStateChanged(user => {
				if (user) {
					user.getIdToken(true).then(idToken => {
						var org = self.getUserOrg()
						switch(name) {
							case "getDepts":
								self.getDepts(idToken, org)
								break;
							case "addUpdateDept":
								self.addUpdateDept(idToken, org)
								break;
							case "deleteDept":
								self.deleteDept(idToken, org)
								break;
							default:
								console.log("Unknown function: " + name)
						}
					})
				}
				else {
					self.alert = "Please login first."
				}
			})
		},

        // Fetch depts for the given org
        getDepts(authToken, org) {
            var self = this
			self.alert = null

			axios({
					method: 'POST',
					baseURL: process.env.VUE_APP_ROOT_API,
					url: '/GetDepartments/',
					headers: {
						'Authorization': 'Bearer ' + authToken,
						'OrgId': org,
						'Content-Type': 'multipart/form-data',
					},
				})
				.then(function (response) {
					if (response.data.err != ''){
						self.alert = response.data.err
					}
					else {
						self.rowDepts = response.data.deptList
					}
				})
				.catch(function (error) {
					self.alert = String(error)
				})
		},

		rowChanged(params){	
			// Current selected Row
			if (this.curRowSelected != null){
				// If new row is not same as previous row, uncheck previous row
				if (this.curRowSelected.originalIndex!=params.row.originalIndex)
					this.curRowSelected.vgtSelected = false
			}
			// New selected row
			this.curRowSelected = params.row
		},

		// Open details for existing department
		openExistingDeptDetails(){
            var self = this
			self.alert = null

            // Check if Department is selected
			if (self.curRowSelected==null){
				self.alert = "Department not selected."
				return
			}

			// Initialize department object
			self.dept.deptDocId = self.curRowSelected.deptDocId
			self.dept.name = self.curRowSelected.name
			self.dept.inTime = self.curRowSelected.inTime
			self.dept.inTimeTolerance = self.curRowSelected.inTimeTolerance
			self.dept.outTime = self.curRowSelected.outTime
			self.dept.outTimeTolerance = self.curRowSelected.outTimeTolerance
			self.dept.daysOff = self.curRowSelected.daysOff

			// Show modal with department values
			//$('#deptDetailsModal').modal('show')
			this.departmentModal = true
		},

		// Open details for new department
		openNewDeptDetails(){
            var self = this
			self.alert = null

			// Initialize department object
			self.dept.deptDocId = ''
			self.dept.name = ''
			self.dept.inTime = '09:00 AM'
			self.dept.inTimeTolerance = 0
			self.dept.outTime = '05:30 PM'
			self.dept.outTimeTolerance = 0
			self.dept.daysOff = []
			
			// Show modal with department values
			//$('#deptDetailsModal').modal('show')
			this.departmentModal = true
		},

		// Save department changes - for new as well as existing department
        addUpdateDept(authToken, org) {
            var self = this
            this.deptAlert = ""

            if (!self.dept.name) {
                self.deptAlert= 'Department name not specified.'
                return
            }
			var formData = new FormData();
			formData.append("deptDocId", self.dept.deptDocId);
			formData.append("name", self.dept.name);
			formData.append("inTime", self.dept.inTime);
			formData.append("inTimeTolerance", self.dept.inTimeTolerance);
			formData.append("outTime", self.dept.outTime);
			formData.append("outTimeTolerance", self.dept.outTimeTolerance);
			formData.append("daysOff", self.dept.daysOff);

			axios({
					method: 'POST',
					baseURL: process.env.VUE_APP_ROOT_API,
					url: '/AddUpdateDepartment/',
					data: formData,
					headers: {
						'Authorization': 'Bearer ' + authToken,
						'OrgId': org,
						'Content-Type': 'multipart/form-data'
					}
				})
				.then(function (response) {
					if (response.data.err != '') {
						self.deptAlert = response.data.err
					}
					else {
						// Refresh department list on the screen
						self.serverCall('getDepts')						
						//$('#deptDetailsModal').modal('hide')
						self.departmentModal = false
					}
				})
				.catch(function (error) {
					self.deptAlert = String(error)
				})
		},

		// Delete Department
		deleteDept(authToken, org){
			var self = this
			
            // Check if Department is selected
			if (self.curRowSelected==null){
				self.alert = "Department not selected."
				return
			}

			// Initialize department object
			var formData = new FormData();
			formData.append("deptDocId", self.curRowSelected.deptDocId);

			axios({
					method: 'POST',
					baseURL: process.env.VUE_APP_ROOT_API,
					url: '/DeleteDepartment/',
					data: formData,
					headers: {
						'Authorization': 'Bearer ' + authToken,
						'OrgId': org,
						'Content-Type': 'multipart/form-data'
					}
				})
				.then(function (response) {
					if (response.data.err != ''){
						self.alert = response.data.err
					}
					else {
						// Refresh department list on the screen
						self.serverCall('getDepts')	
					}			
				})
				.catch(function (error) {
					console.log(String(error))
					self.alert = String(error)
				})
		},

	},

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


</style>
